<template>
  <div class="station-block">
    <div class="tab-wrap">
      <div
        class="tab-item"
        :class="{ 'tab-active': current == 1 }"
        @click="changeTab(1)"
      >
        服务站（{{ servicePageCount }}个）
      </div>
      <div
        class="tab-item"
        :class="{ 'tab-active': current == 2 }"
        @click="changeTab(2)"
      >
        联络站（{{ liaisonPageCount }}个）
      </div>
    </div>
    <div class="station-block" v-if="stationList.length && current == 1">
      <div class="list">
        <div
          class="item hover-item"
          v-for="(item, index) in stationList"
          :key="index"
          @click="toDetail(item)"
        >
          <img class="cover-image" mode="aspectFit" :src="item.schoolIcon" />
          <div class="content">
            <div class="title">{{ item.serviceStation }}</div>
            <div class="desc">
              <span>{{ item.city }}</span>
              <span>站长：{{ item.contactManList }}</span>
            </div>
            <div class="count">
              <span>政策服务({{ item.policyNum }})</span>&nbsp;&nbsp;
              <span>赛事活动服务({{ item.competitionNum }})</span>
            </div>
            <div class="extend">
              <div class="name">
                <span class="s">{{ item.liaisonNum }}个站</span>
                <div class="t">{{ item.schoolName }}</div>
                <span class="icon iconfont icon-more-t"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="m-pager">
        <el-pagination
          background
          layout="prev, pager, next"
          prev-text="上一页"
          next-text="下一页"
          :page-size="limit"
          :total="servicePageCount"
          @current-change="changePageClick"
        >
        </el-pagination>
      </div>
    </div>
    <div class="station-block" v-if="LiasonList.length && current == 2">
      <div class="list">
        <div
          class="item hover-item"
          v-for="(item, index) in LiasonList"
          :key="index"
          @click="toDetail(item)"
        >
          <img class="cover-image" mode="aspectFit" :src="item.schoolIcon" />
          <div class="content">
            <div class="title">{{ item.liaisonName }}</div>
            <div class="desc">
              <span>{{ item.city }}</span>
              <span>联络员：{{ item.contactManList }}</span>
            </div>
            <div class="count">
              <span>政策服务({{ item.policyNum }})</span>&nbsp;&nbsp;
              <span>赛事活动服务({{ item.competitionNum }})</span>
            </div>
            <div class="extend">
              <div class="name">
                <div class="t">{{ item.serviceStation }}</div>
                <span class="icon iconfont icon-more-t"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="m-pager">
        <el-pagination
          background
          layout="prev, pager, next"
          prev-text="上一页"
          next-text="下一页"
          :page-size="limit"
          :total="liaisonPageCount"
          @current-change="changePageClick"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
// import {
//   getStationList
// } from "@/api/home/home.js";
import {
  getServiceStationList,
  getLiaisonStationList,
  getStaionCount,
} from "@/api/station/station.js";
export default {
  props: {
    // list: {
    //   type: Array,
    //   default: () => [],
    // },
  },
  data() {
    return {
      stationList: [],
      LiasonList: [],
      limit: 10,
      current: 1,
      servicePageCount: 0,
      liaisonPageCount: 0,
    };
  },
  created() {
    this.getStaionCount();
    this.getStationList();
  },
  methods: {
    getStaionCount() {
      getStaionCount().then((res) => {
        this.liaisonPageCount = res.data.liaison_station;
        this.servicePageCount = res.data.service_station;
      });
    },
    getStationList(page = 1) {
      const params = {
        page: page,
        limit: this.limit,
      };
      getServiceStationList(params).then((res) => {
        this.stationList = res.data.stationList;
      });
    },
    getLiasonList(page = 1) {
      const params = {
        page: page,
        limit: this.limit,
      };
      getLiaisonStationList(params).then((res) => {
        this.LiasonList = res.data.stationList;
      });
    },
    changeTab(e) {
      this.current = e;
      if (e == 1) return this.getStationList();
      if (e == 2) return this.getLiasonList();
    },
    //切换页面
    changePageClick(page) {
      this.loading = true;
      if (this.current == 1) return this.getStationList(page);
      if (this.current == 2) return this.getLiasonList(page);
    },
    toDetail(item) {
      this.$router.push({
        path: "/station/stationDetail/" + item.stationId,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.station-block {
  margin-bottom: 30px;
  .tab-wrap {
    display: flex;
    margin: 30px;
    border-bottom: 1px solid #eaeaea;

    .tab-item {
      font-size: 20px;
      color: #303133;
      padding: 10px 0;
      margin: 0 40px;
      cursor: pointer;
    }

    .tab-active {
      color: #87c4f7;
      border-bottom: 6px solid #87c4f7;
    }
  }
  .m-pager {
    margin: 24px 0;

    .el-pagination {
      display: flex;
      justify-content: center;

      /deep/ .btn-prev {
        width: 100px;
        height: 40px;
        border: 1px solid #e4e4e4;
        background-color: #fff;
      }

      /deep/ .btn-prev:hover:enabled {
        color: #409eff;
      }

      /deep/ .number {
        width: 40px;
        height: 40px;
        line-height: 40px;
        border: 1px solid #e4e4e4;
        background-color: #fff;
      }

      /deep/ .more {
        width: 40px;
        height: 40px;
        line-height: 40px;
        border: 1px solid #e4e4e4;
        background-color: #fff;
      }

      /deep/ .btn-next {
        width: 100px;
        height: 40px;
        border: 1px solid #e4e4e4;
        background-color: #fff;
      }

      /deep/ .active {
        color: #fff;
        background-color: #409eff;
      }

      /deep/ .btn-next:hover:enabled {
        color: #409eff;
      }
    }
  }
}
.station-block {
  flex: 1;
  padding: 0 20px;
  margin: 20px 0;
}
.list {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  .item {
    width: calc(50% - 26px);
    display: flex;
    position: relative;
    padding: 15px 0 15px 15px;
    border: 1px solid rgba(229, 229, 229, 1);
    box-shadow: -4px 3px 15px rgba(173, 213, 255, 0.5);
    border-radius: 10px;
    margin-bottom: 26px;
    .cover-image {
      width: 110px;
      height: 110px;
      border-radius: 10px;
      overflow: hidden;
    }

    .content {
      flex: 1;
      display: flex;
      flex-direction: column;
      padding-left: 20px;

      .title {
        font-size: 20px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
      }

      .desc {
        color: #999;
        font-size: 14px;
        margin-top: 0.2em;

        span:nth-child(2)::before {
          content: "|";
          margin: 0 0.5em;
          font-size: 14px;
          color: #ddd;
        }
      }

      .count {
        color: #488dcc;
        font-size: 14px;
        margin-top: 0.2em;

        text:nth-child(2) {
          margin-left: 0.5em;
        }
      }

      .extend {
        font-size: 14px;
        flex: 1;
        display: flex;
        align-items: flex-end;
        line-height: 1;
        color: #454545;
        margin-top: 0.5em;

        .name {
          display: flex;
          align-items: center;
          background-color: #f5f5f5;
          height: 28px;
          width: 60%;
          padding: 16px 20px;
          border-radius: 20px;
          overflow: hidden;

          .s {
            color: #488dcc;
            margin-right: 0.2em;
          }

          .t {
            flex: 1;
            text-align: center;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
          }
        }
      }
    }
  }

  .item::after {
    position: absolute;
    bottom: 0;
    right: 0;
    left: 0;
    content: "";
    height: 1px;
    background-color: #f0f0f0;
    overflow: hidden;
  }

  .item:last-child::after {
    display: none;
  }
}
</style>